import React, { useEffect, useState, useMemo, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '@/models';
import { useTranslation } from 'react-i18next';
import { Button, Form, Input } from 'antd';
import backcircle from '@/assets/common/backcircle.png';
import cx from 'classnames';
import CaptchaBtn from '@/components/captchaBtn';
import BackIcon from '@/components/icons/BackIcon';

import encrypt from '@/utils/encrypt';
import { accountFormat } from '@/utils/utils';
import cs from './index.module.scss';

interface UserInfo {
  inviteCode?: number | string;
  telCountryCode?: number | string;
  username: number | string;
  password: number | string;
}
interface Props {
  currentTab: string;
  back: () => void;
  userInfo: UserInfo;
}

const RegisterNextStep: React.FC<Props> = ({ currentTab, back, userInfo }) => {
  const { t } = useTranslation();
  const { account, ui } = useStore();
  const [loading, setLoading] = useState(false); // 第一个登录按钮
  const [isDisabled, setIsDisabled] = useState(true); //按钮禁用
  const { judgeToken, fetctRegister, setLoginUserName } = account;
  const [form] = Form.useForm();
  const codePlaceholder = useMemo(() => (currentTab === 'phone' ? t('common.sjyzm') : t('common.yxyam')), [currentTab]);
  const codeLabel = useMemo(
    () =>
      currentTab === 'phone'
        ? t('common.sjyzmdsj', { tel: accountFormat(userInfo.username) })
        : t('common.yxzdyx', { email: accountFormat(userInfo.username) }),
    [currentTab],
  );

  const onFinish = (values: any) => {
    setLoading(true);
    const { verifyCode } = values;
    const data = {
      username: userInfo.username,
      verifyCode,
      inviteCode: userInfo?.inviteCode,
      password: encrypt(userInfo?.password),
      telCountryCode: userInfo?.telCountryCode,
      judgeToken,
    };
    fetctRegister(data)
      .then(res => {
        console.log(res);
        if (res) {
          setLoginUserName({
            username: currentTab === 'email' ? String(userInfo.username) : '',
            password: '',
            telCountryCode: String(userInfo.telCountryCode || '86'),
          });
          ui.hideRegisterModal();
          ui.showLoginModal();
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((err: any) => {
        console.log(err);
        setLoading(false);
      });
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  // 监听验证码输入变化
  const handleValuesChange = (changedValues: any) => {
    const { verifyCode } = form.getFieldsValue();
    setIsDisabled(!verifyCode || verifyCode.trim().length === 0);
  };

  return (
    <div className={cs.content}>
      <div className={cx(cs.content_info)}>
        <Form
          form={form}
          name="basic"
          labelCol={{ flex: 1 }}
          wrapperCol={{ flex: 1 }}
          labelAlign="left"
          // initialValues={{ telCountryCode: '86', inviteCode: invite }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          layout="vertical"
          requiredMark={false}
          onValuesChange={handleValuesChange}
        >
          <Form.Item
            label={<span className={cs.verifyCodeLabel}>{codeLabel}</span>}
            name="verifyCode"
            rules={[{ required: true, message: t('signUp.codePlace') }]}
          >
            <Input
              className="bgIptAddonAfter"
              placeholder={codePlaceholder}
              addonAfter={<CaptchaBtn username={userInfo.username} telCountryCode={userInfo.telCountryCode} />}
            />
          </Form.Item>

          <div className={cs.btn}>
            <Button
              loading={loading}
              type="primary"
              htmlType="submit"
              className={cx('btnPrimary', cs.registerBtn)}
              style={{ height: '40px', width: '100%' }}
              disabled={isDisabled}
            >
              {t('btn.ok')}
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default observer(RegisterNextStep);
